import { CircleCheck } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

const POINTS = [
  "Kirim pengaduan lengkap dengan foto/video",
  "Pantau progres penyelesaian dari nomor tiket",
  "Balas tanggapan pengurus RT langsung di aplikasi",
];

export const AuthLayout = ({ title, description, children, testId }) => (
  <main className="mx-auto flex max-w-5xl px-4 py-8 sm:py-14" data-testid={testId}>
    <div className="fade-up grid w-full overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-xl md:grid-cols-[0.85fr_1.15fr]">
      <aside className="relative hidden overflow-hidden bg-slate-900 p-10 text-white md:flex md:flex-col md:justify-between">
        <div className="absolute -bottom-20 -left-16 h-64 w-64 rounded-full bg-emerald-500/30 blur-3xl" />
        <div className="grain absolute inset-0" />
        <BrandMark className="relative" />
        <div className="relative">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-300">Vila Nusa Indah 5 · Cluster Merak</p>
          <h2 className="mt-2 font-heading text-3xl font-extrabold leading-tight">Layanan Pengaduan Warga</h2>
          <ul className="mt-6 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex gap-2.5 text-sm text-slate-300">
                <CircleCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" /> {p}
              </li>
            ))}
          </ul>
        </div>
      </aside>
      <div className="space-y-5 p-6 sm:p-10">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-slate-900">{title}</h2>
          <p className="mt-1 text-sm text-slate-500">{description}</p>
        </div>
        {children}
      </div>
    </div>
  </main>
);

export const FormError = ({ message, testId }) =>
  message ? (
    <p className="rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-medium text-rose-700" data-testid={testId}>{message}</p>
  ) : null;
